webpackJsonp([193211362525136],{

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'constants/PayloadStates.js'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This file is where you should store any custom PayloadStates required for your application.  It is populated by default with the PayloadStates that Lore uses for the action and reducer blueprints.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'PayloadStates are how you can tell what\'s happening to a resource within your application.  For example, all data passed around a Lore app has the following format:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n       const datum = {\n         id: \'1\',\n         cid: \'c1\',\n         state: [PayloadState],\n         data: {\n           title: \'Explain PayloadStates\',\n           isCompleted: false\n         },\n         error: {..some error object..}\n       }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' field always contains one of the PayloadState properties, like ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'FETCHING'
	      ),
	      ' or ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'UPDATING'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This structure allows your components to be able to know and react to transitional states within your data.  For example, if a component gets some data that has a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'FETCHING'
	      ),
	      ', it will know the data is currently being retrieved from the server and it should maybe show a spinner or some other kind of waiting message.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' is ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'RESOLVED'
	      ),
	      ', the component will know the data is stable (nothing in flight) and if the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' is ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'UPDATING'
	      ),
	      ' it would know that the application is currently waiting on confirmation from the server about a change to the data.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'ERROR_*'
	      ),
	      ' states exist in case there\'s an error performing an operation on the server side and you want to articulate to the user what failed (Create, Update, Delete, etc.) and perhaps give them an opportunity to modify the request and try again.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Defaults'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default file included in new projects looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import { PayloadStates } from \'lore-utils\';\n      import _ from \'lodash\';\n\n      /*\n       * The default payload states are listed below.\n       */\n\n      export default _.defaults({\n        // INITIAL_STATE: \'INITIAL_STATE\',\n        //\n        // RESOLVED   : \'RESOLVED\',\n        // NOT_FOUND: \'NOT_FOUND\',\n        // DELETED: \'DELETED\',\n        //\n        // CREATING: \'CREATING\',\n        // UPDATING: \'UPDATING\',\n        // DELETING: \'DELETING\',\n        // FETCHING: \'FETCHING\',\n        //\n        // ERROR_CREATING: \'ERROR_CREATING\',\n        // ERROR_UPDATING: \'ERROR_UPDATING\',\n        // ERROR_DELETING: \'ERROR_DELETING\',\n        // ERROR_FETCHING: \'ERROR_FETCHING\'\n      }, PayloadStates);\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-src-constants-payload-states-js-eec5bf405dddb004b6ef.js